import React, { useState } from "react";
import Img from "gatsby-image";


// Styles
import * as styles from './video.module.scss'

const Video = ({ videoSrcURL, videoTitle, autoplay, ...props }) => {

    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    const onLoadedData = () => {
        setIsVideoLoaded(true);
    };

    return(
        <div className={styles.cdVideo}>
            {
                props.thumb ?
                    <Img
                        fluid={props.thumb}
                        className={`${styles.cdVideoThumb} ${styles.cdTiny}`}
                        style={{ opacity: isVideoLoaded ? 0 : 1 }}
                    />
                    :
                    ''
            }

            <video
                poster={props.poster}
                loop
                muted
                playsInline
                autoPlay={autoplay}
                onLoadedData={onLoadedData}
                /*style={{ opacity: isVideoLoaded ? 1 : 0 }}*/
            >
                <source title={videoTitle} src={videoSrcURL} type={`video/${props.format === "webm" ? "webm" : "mp4"}`}/>
            </video>
        </div>
    )
}

export default Video